<script setup lang="ts">
// Vue & Plugins
import { computed } from 'vue'

// Data
const props = defineProps<{
  modelValue: string
}>()
const emit = defineEmits(['update:modelValue'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})
</script>

<template>
  <InputText
    v-model="value"
  />
</template>
